import { globalRemoveMaskReal2 } from "../../../../../shared/utils";
import { ClientCompanyData, FireQuotePayload } from "../types";

interface QuotationDependencies {
	clientId: string | null;
	companyId: string | null;
	selectionData: any;
	localCoverages: { id?: string | number; value?: string | number }[];
	companyData?: ClientCompanyData;
	totalQuotation: number;
	transformDateToISO: (dateString: string | undefined) => string | null;
	lastRentValue?: number | null;
}

export const mapFormDataToQuotationPayload = (
	formData: any,
	{ clientId, companyId, selectionData, localCoverages, companyData, totalQuotation, transformDateToISO, lastRentValue = null }: QuotationDependencies
): FireQuotePayload => {
	const rentValueNormalized = Number(globalRemoveMaskReal2(selectionData?.rentValue));
	const prizeNormalized = totalQuotation;
	const vigencyStart = transformDateToISO(formData.vigencyStart);

	const brokerageComission = Number(globalRemoveMaskReal2(String(companyData?.comission_broker)));

	let flagRentChanged = false;
	if (typeof lastRentValue === "number" && !isNaN(lastRentValue)) {
		flagRentChanged = rentValueNormalized !== lastRentValue;
	} else {
		flagRentChanged = rentValueNormalized > 0;
	}

	const predialPercent =
		Number(globalRemoveMaskReal2(selectionData?.predialPercent)) || Number(globalRemoveMaskReal2(String(companyData?.pc_predio ?? "80,00")));

	const contentPercent =
		Number(globalRemoveMaskReal2(selectionData?.contentPercent)) || Number(globalRemoveMaskReal2(String(companyData?.pc_conteudo ?? "20,00")));

	const coveragesPayload = localCoverages.map((c) => ({
		id: c.id!,
		coverage_value: Number(globalRemoveMaskReal2(String(c.value ?? 0))),
	}));

	const quotationPayload: FireQuotePayload = {
		clientId: clientId ?? "",
		insurance_companiesId: companyId ?? "",
		occupationId: selectionData?.occupationId ?? "",
		assistanceId: selectionData?.assistanceId ?? "",
		brokerageId: companyData?.brokerage_code ?? "",
		rent_value: rentValueNormalized,
		insurance_prize: prizeNormalized,
		brokerage_comission_percent_amount: brokerageComission,
		prolabore_percent_amount: Number(globalRemoveMaskReal2(String(formData?.prolabore_percent_amount))),
		pc_predial: predialPercent,
		pc_content: contentPercent,
		validity_start: vigencyStart ?? new Date().toISOString(),
		monthly_validity: formData.vigencyMonths ?? formData.installments ?? 12,
		flag_rent_changed: flagRentChanged,
		coverages: coveragesPayload,
	};

	return quotationPayload;
};
